const initialState = {
  activeTab: 'attributes'
}
export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  mutations: {
    resetStateData(state) {
      for (let prop in state) {
        state[prop] = initialState[prop]
      }
    },
    setActiveTab(state, tabName) {
      state.activeTab = tabName
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js